import { isBootFeatureEnabled } from "owa-metatags";
import { hasQueryStringParameter } from "owa-querystring";

export function patchPerformance(): void {
    if (isBootFeatureEnabled("disableperfmeasure") && !hasQueryStringParameter("profile")) {
        if (typeof self.performance?.measure === "function") {
            self.performance.measure = name => ({
                detail: null,
                entryType: "measure",
                name,
                startTime: -1,
                duration: -1,
            }) as any;
        }
        if (typeof self.performance?.mark === "function") {
            self.performance.mark = name => ({
                detail: null,
                entryType: "mark",
                name,
                startTime: -1,
                duration: -1,
            }) as any;
        }
    }
}
